import { FeatureFlags } from '@/app/shared/constants/featureFlags';

const healthKeyRoutes = [
  {
    path: '/healthkey',
    name: 'HealthKeyShop',
    component: () => import('./healthKeyShop.vue'),
    meta: {
      title: 'HealthKey',
      requiresAuth: true,
    },
  },
];

// Not registered while the flag is off, so /healthkey falls through to the 404 route.
export default FeatureFlags.HealthKeyShop ? healthKeyRoutes : [];
